<template>
  <div class="app-container asset-po-page">
    <!-- 搜索条件 -->
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="PO单号">
                <el-input v-model="searchForm.opTicketid" placeholder="请输入PO单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="DCOPS单号">
                <el-input
                  v-model="searchForm.dcops_ticket_id"
                  placeholder="请输入DCOPS单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="机房名称">
                <el-input v-model="searchForm.idc_name" placeholder="请输入机房名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="任务名称">
                <el-input v-model="searchForm.task_name" placeholder="请输入任务名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="是否超时">
                <el-select
                  v-model="searchForm.is_expired"
                  placeholder="请选择"
                  clearable
                  style="width: 100%"
                >
                  <el-option label="未超时" :value="0" />
                  <el-option label="已超时" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="openColumnsDialog">列设置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      class="po-detail-table"
    >
      <el-table-column
        v-for="column in visibleColumns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth || 120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="column.prop === 'assets_data'">
            <json-view-dialog
              :content="scope.row[column.prop]"
              :title="column.label"
              width="85%"
              :max-height="560"
            />
          </span>
          <span v-else-if="column.prop === 'is_expired'">
            <el-tag
              :type="scope.row[column.prop] === 1 ? 'danger' : scope.row[column.prop] === 0 ? 'success' : 'info'"
              size="small"
            >
              {{ scope.row[column.prop] === 1 ? '已超时' : scope.row[column.prop] === 0 ? '未超时' : '-' }}
            </el-tag>
          </span>
          <span v-else-if="column.prop === 'expire_time' || column.prop === 'finished_time'">
            {{
              scope.row[column.prop]
                ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                : '-'
            }}
          </span>
          <span v-else>{{ scope.row[column.prop] || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 列设置对话框 -->
    <el-dialog title="列设置" :visible.sync="showColumnsDialog" width="400px" append-to-body>
      <el-checkbox-group v-model="selectedColumns">
        <div v-for="column in columns" :key="column.prop" style="margin-bottom: 10px">
          <el-checkbox :label="column.prop">{{ column.label }}</el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showColumnsDialog = false">取消</el-button>
        <el-button @click="selectAllColumns">全选</el-button>
        <el-button @click="restoreDefaultColumns">恢复默认</el-button>
        <el-button type="primary" @click="saveColumnsDialog">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { assetConfirmAppendix } from '@/api/appManage';
import JsonViewDialog from '@/components/JsonViewDialog';

export default {
  name: 'AssetBillingDetail',
  components: { JsonViewDialog },
  props: {
    opTicketid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchForm: {
        id: '',
        opTicketid: this.opTicketid || '',
        dcops_ticket_id: '',
        idc_name: '',
        task_name: '',
        is_expired: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showColumnsDialog: false,
      selectedColumns: [
        'id',
        'opTicketid',
        'po_ticket_id',
        'dcops_ticket_id',
        'bill_weight',
        'assets_data',
        'idc_name',
        'task_name',
        'is_expired',
        'finished_time',
      ],
      defaultSelectedColumns: [
        'id',
        'opTicketid',
        'po_ticket_id',
        'dcops_ticket_id',
        'bill_weight',
        'assets_data',
        'idc_name',
        'task_name',
        'is_expired',
        'finished_time',
      ],
      columns: [
        { prop: 'id', label: 'ID', width: 80 },
        { prop: 'opTicketid', label: '鸿运侧PO工单号', width: 150 },
        { prop: 'po_ticket_id', label: '腾汛侧PO工单号', width: 150 },
        { prop: 'dcops_ticket_id', label: '工作工单号', width: 150 },
        { prop: 'bill_weight', label: '计费权重', width: 100 },
        { prop: 'assets_data', label: '资产数据', width: 120 },
        { prop: 'check_memo', label: '确认信息', width: 150 },
        { prop: 'check_remark', label: '备注', width: 200 },
        { prop: 'expire_time', label: '超时时间', width: 160 },
        { prop: 'idc_name', label: '机房名称', width: 150 },
        { prop: 'ticket_instance_name', label: '流程标识', width: 150 },
        { prop: 'task_name', label: '任务名称', width: 150 },
        { prop: 'is_expired', label: '是否超时', width: 100 },
        { prop: 'finished_time', label: '完成时间' },
        { prop: 'completer', label: '结单人' },
      ],
    };
  },
  computed: {
    visibleColumns() {
      return this.columns.filter((column) => this.selectedColumns.includes(column.prop));
    },
  },
  watch: {
    opTicketid: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.searchForm.opTicketid = newVal;
          this.fetchData();
        }
      },
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          skip: this.currentPage,
          limit: this.pageSize,
          opTicketid: this.searchForm.opTicketid,
          dcops_ticket_id: this.searchForm.dcops_ticket_id,
          idc_name: this.searchForm.idc_name,
          task_name: this.searchForm.task_name,
          is_expired: this.searchForm.is_expired,
        };
        
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });
        
        const response = await assetConfirmAppendix(params);
        if (response && response.data.code === 200) {
          this.tableData = response.data.data.list || [];
          this.total = response.data.data.total || 0;
        } else {
          this.$message.error(response.message || '获取数据失败');
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败，请稍后重试');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset() {
      this.searchForm = {
        id: '',
        opTicketid: this.opTicketid || '',
        dcops_ticket_id: '',
        idc_name: '',
        task_name: '',
        is_expired: '',
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((col) => col.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}
::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}
/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>
